import type { MantineThemeOverride } from "@mantine/core";

import type { WhitelabelBrandTheme } from "@/configs/whitelabel";

export const defaultWhitelabelTheme: MantineThemeOverride = {
  // prettier-ignore
  colors: {
    primary: ["#E7E9EB","#B7BCC3","#87909B","#566373","#3E4D5F","#26364B","#0E2037","#0B1A2C","#081321","#060D16"],
    secondary: ["#F6FBF8","#E5F4EA","#D4EDDC","#C2E6CD","#B9E2C6","#B1DFBF","#A8DBB8","#86AF93","#65836E","#43584A"]
  },
  other: {
    logo: "/storage/v1/object/public/whitelabel/waku/logo.png", // Supabase Storage URI (without prefix)
    logoLocal: "/whitelabel/waku/logo.png", // src/public/...
  },
};

// prettier-ignore
export const whitelabelThemes: Record<WhitelabelBrandTheme, MantineThemeOverride> = {
  waku: defaultWhitelabelTheme,
  logisticsag: {
    colors: {
      primary: ["#FBE9ED","#F3BDC8","#EB91A3","#E2647E","#DE4E6B","#DA3859","#D62246","#AB1B38","#80142A","#560E1C"],
      secondary: ["#E8F9F8","#B9ECEB","#8BDFDD","#5DD2CF","#45CBC9","#2EC5C2","#17BEBB","#129896","#0E7270","#094C4B"]
    },
    other: {
      logo: '/storage/v1/object/public/whitelabel/logistics-ag/logo.png', // Supabase Storage URI (without prefix)
      logoLocal: '/whitelabel/logistics-ag/logo.png', // src/public/...
    }
  },
  meili: {
    colors: {
      primary: ["#F0E7F4","#D2B7DF","#B487CA","#9556B5","#863EAA","#7726A0","#680E95","#530B77","#3E0859","#2A063C"],
      secondary: ["#F7EEFE","#E6CCFB","#D6AAF8","#C688F5","#BD77F4","#B566F2","#AD55F1","#8A44C1","#683391","#452260"]
    },
    other: {
      logo: '/storage/v1/object/public/whitelabel/meili/logo.png', // Supabase Storage URI (without prefix)
      logoLocal: '/whitelabel/meili/logo.png', // src/public/...
    }
  },
  hai: {
    colors: {
      primary: ["#EAEAFF","#C0C1FE","#9798FD","#6D6FFC","#585AFB","#4346FB","#2E31FA","#2527C8","#1C1D96","#121464"],
      secondary: ["#F3F4FE","#DCDDFD","#C5C6FC","#AEAFFA","#A2A3F9","#9798F9","#8B8CF8","#6F70C6","#535495","#383863"]
    },
    other: {
      logo: '/storage/v1/object/public/whitelabel/hai/logo.png', // Supabase Storage URI (without prefix)
      logoLocal: '/whitelabel/hai/logo.png', // src/public/...
    }
  },
  safelog: {
    colors: {
      primary: ["#E8E9E9","#BBBCBD","#8D9092","#5F6366","#494D50","#32363A","#1B2024","#161A1D","#101316","#0B0D0E"],
      secondary: ["#FDEEE6","#F9CDB4","#F5AC83","#F08B51","#EE7A38","#EC6A1F","#EA5906","#BB4705","#8C3504","#5E2402"]
    },
    other: {
      logo: '/storage/v1/object/public/whitelabel/safelog/logo.png', // Supabase Storage URI (without prefix)
      logoLocal: '/whitelabel/safelog/logo.png', // src/public/...
    }
  },
};
